<vloket-home-header
	[userName]="user()?.firstName"
	[primaryLinks]="primaryHeaderLinks"
	[secondaryLinks]="secondaryHeaderLinks()"
	[secondaryLinksLoading]="secondaryHeaderLinksLoading()"
/>

<vloket-association-passport-section
	[associationLoading]="myAssociationLoading()"
	[associationError]="myAssociationError()"
	[associationName]="user()?.company?.name"
	[associationProgress]="myAssociationProgress()"
	[associationProgressCompleted]="myAssociationProgressCompleted()"
/>

<vloket-in-the-spotlight-section
	[adviceLoading]="adviceLoading()"
	[spotlightItemsLoading]="spotlightItemsLoading()"
	[advicePages]="advicePages()"
	[spotlightItems]="spotlightItems()"
	[settingProductAsFavorite]="settingProductAsFavorite()"
	(setItemAsFavoriteClicked)="handleSetAsFavorite($event)"
	(removeItemAsFavoriteClicked)="handleRemoveAsFavorite($event)"
/>

<vloket-we-grow-together-section />

<vloket-about-us-section />

<vloket-newsletter />
